import React from 'react';
import '../styles/Footer.css';

const Footer = () => (
  <footer className="footer">
   @ icityEducation.com
  </footer>
);

export default Footer;
